import React from "react";
import "./style.scss";
import { Tabs as AntTabs } from "antd";

function Tabs({
  variant = "primary",
  isCentered,
  className = "",
  onChange,
  items,
  defaultActiveKey = "1",
  position = "top",
  extraContent,
  activeKey,
  destroyInactiveTabPane = false,
}) {
  return (
    <AntTabs
      activeKey={activeKey}
      destroyInactiveTabPane={destroyInactiveTabPane}
      tabBarExtraContent={extraContent}
      defaultActiveKey={defaultActiveKey}
      tabPosition={position}
      centered={isCentered}
      items={items}
      onChange={onChange}
      className={`${variant === "primary" ? "tabs-primary" : "tabs-secondary"} ${className}`}
    />
  );
}

export default Tabs;
